// Зөвлөхийн layout (Tomujin DS, багшийн layout-тай ижил хэв): Нүүр · Уулзалтууд · Сурагчид · Цагийн хуваарь, мэдэгдэл, профайл.
// Утсанд доод цэс.
import React, { useContext, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Dropdown } from "antd";
import { BiCalendarPlus, BiConversation, BiGroup, BiHomeAlt, BiUserCircle } from "react-icons/bi";
import { AuthContext } from "contexts";
import { usePortal, clearPortalMode, switchItems } from "contexts/portal";
import NotificationBell from "layout/components/header/NotificationBell";
import logo from "assets/images/logo.png";
import { Avatar, prefetch, useCached } from "./common";
import "modules/teacher/tj.css";

const NAV = [
  { to: "/c", label: "Нүүр", icon: BiHomeAlt, match: (p) => p === "/c" },
  { to: "/c/sessions", label: "Уулзалтууд", icon: BiConversation, match: (p) => p.startsWith("/c/session") },
  { to: "/c/students", label: "Сурагчид", icon: BiGroup, match: (p) => p.startsWith("/c/students") },
  { to: "/c/slots", label: "Цагийн хуваарь", short: "Цаг", icon: BiCalendarPlus, match: (p) => p.startsWith("/c/slots") },
];

export default function CounselorLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { action } = useContext(AuthContext);
  const portal = usePortal();
  const { data: me } = useCached("/counselor/profile");
  useEffect(() => {
    prefetch("/counselor/home");
    setTimeout(() => prefetch("/counselor/meetings", { scope: "all" }), 1200);
  }, []);
  const path = location.pathname;

  const logout = () => { clearPortalMode(); action.logout(); navigate("/login"); };
  const menu = {
    items: [
      { key: "profile", label: "Хувийн мэдээлэл", onClick: () => navigate("/me") },
      ...switchItems(portal, navigate),
      { type: "divider" },
      { key: "logout", label: "Гарах", onClick: logout },
    ],
  };

  return (
    <div className="tj pb-20 md:pb-0">
      <header className="tj-header">
        <div className="tj-container py-2.5 flex flex-wrap items-center gap-x-7 gap-y-2">
          <Link to="/c" aria-label="Нүүр" className="shrink-0"><img src={logo} height={34} style={{ height: 34, width: "auto" }} alt="Tomujin Alternative School" /></Link>
          <nav aria-label="Үндсэн цэс" className="tj-nav hidden md:flex flex-wrap gap-1 flex-1">
            {NAV.map((n) => <Link key={n.to} to={n.to} aria-current={n.match(path) ? "page" : undefined}>{n.label}</Link>)}
          </nav>
          <div className="ml-auto flex items-center gap-3">
            <NotificationBell />
            <Dropdown menu={menu} trigger={["click"]} placement="bottomRight">
              <button type="button" className="flex items-center gap-2.5 bg-transparent border-0 cursor-pointer p-0" style={{ fontFamily: "inherit" }}>
                <Avatar user={me} size={36} tone="purple" />
                <span className="hidden sm:flex flex-col text-left leading-tight">
                  <span className="text-sm font-semibold text-[#1c1c1c]">{me ? `${me.lastName?.[0] || ""}. ${me.firstName}` : ""}</span>
                  <span className="text-xs text-[#6e5e8a]">{me?.title || "Зөвлөх"}</span>
                </span>
              </button>
            </Dropdown>
          </div>
        </div>
      </header>
      <main>{children}</main>
      <nav aria-label="Үндсэн цэс" className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-[#e5d8f5] grid" style={{ gridTemplateColumns: `repeat(${NAV.length + 1}, minmax(0, 1fr))`, paddingBottom: "env(safe-area-inset-bottom)" }}>
        {[...NAV, { to: "/me", label: "Хувийн мэдээлэл", short: "Миний", icon: BiUserCircle, match: (p) => p === "/me" }].map((n) => {
          const on = n.match(path);
          const I = n.icon;
          return (
            <Link key={n.to} to={n.to} aria-current={on ? "page" : undefined} className={`flex flex-col items-center justify-center gap-0.5 min-h-[56px] text-[11px] ${on ? "!text-[#5c1090] font-bold" : "!text-[#6e5e8a] font-semibold"}`}>
              <I size={22} aria-hidden="true" />{n.short || n.label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
